import Cookies from "js-cookie";
import { _cookie, _route } from "./constant";
import dayjs, { Dayjs } from "dayjs";
import sdicHomeEmit from "@/utils/prototal";
import { Toast } from "antd-mobile";
import ClipboardJs from "clipboard";

export function resetApp() {
  const currentCookies = Cookies.get();
  for (const key in currentCookies) {
    Cookies.remove(key);
  }
  localStorage.clear();
}

// export function setApp(cookies: any = {}, storages: any = {}) {
//   for (const key in cookies) {
//     Cookies.set(key, cookies[key]);
//   }
//   for (const key in storages) {
//     localStorage.setItem(key, storages[key]);
//   }
// }

export function extractTextFromHTML(htmlString: string): string {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");
  return doc.body.textContent || doc.body.innerText || "";
}

export function resetAllCookies() {
  const currentCookies = Cookies.get();
  for (const key in currentCookies) {
    Cookies.remove(key);
  }
}

export function setUserCookie(data: any) {
  for (const key in data) {
    if (key !== _cookie.TOKEN) {
      Cookies.set(key, data[key]);
    }
  }
}

export function handleH5AppClick(clickUrl: string) {
  if (isSdicHomeApp()) {
    sdicHomeEmit("openPage", {
      click_type: "H5",
      click_url: clickUrl,
    });
  } else {
    window.location.href = clickUrl;
  }
}

export function handleH5AppClickUrl(clickUrl: string) {
  const url = `${window.location.origin}${process.env.PUBLIC_URL}${clickUrl}`;
  if (isSdicHomeApp()) {
    sdicHomeEmit("openPage", {
      click_type: "H5",
      click_url: url,
    });
  } else {
    window.location.href = url;
  }
}

export function handleJumpUrl(params: { clickType?: string; clickUrl?: string }) {
  const { clickType, clickUrl } = params;
  if (clickUrl) {
    if (isSdicHomeApp()) {
      sdicHomeEmit("openPage", {
        click_type: clickType || "H5",
        click_url: clickUrl,
      });
    } else {
      if (clickType === "TOAST") {
        Toast.show(clickUrl);
        return;
      }
      window.location.href = clickUrl;
    }
  }
}

interface LoadScriptProps {
  url: string;
  id?: string;
  tryCount?: number; // 重试次数
  onSuccess?: () => void;
  onError?: () => void;
}

export function importScript({
  url,
  id = "outerScript",
  onSuccess,
  onError,
}: LoadScriptProps): Promise<boolean> {
  if (document.getElementById(id)) {
    onSuccess?.();
    return Promise.resolve(true);
  }

  return new Promise((resolve, reject) => {
    const _script = document.createElement("script");
    _script.setAttribute("type", "text/javascript");
    _script.setAttribute("id", id);
    _script.setAttribute("src", url);
    document.getElementsByTagName("head")[0].appendChild(_script);
    _script.onload = () => {
      onSuccess?.();
      resolve(true);
    };
    _script.onerror = () => {
      onError?.();
      reject();
    };
  });
}

// 多次请求，避免js加载失败
export const loadScript = ({ tryCount, ...rest }: LoadScriptProps) => {
  let count = tryCount || 4;

  const load = () => {
    importScript({
      ...rest,
      onError() {
        count--;
        if (count > 0) {
          load();
        }
      },
    });
  };
  load();
};

export const getSelector = (selector: string | Element | null): Element | null => {
  if (typeof selector === "string") {
    const dom = document.querySelector(selector);
    if (dom) {
      return dom;
    }
    return document.body;
  }
  return selector;
};

/**
 * 是否是国投幸福家的APP
 */
export const isSdicHomeApp = () => {
  const u = navigator.userAgent;

  return /sdichome/i.test(u);
};

export const isAndroid = () => {
  const u = navigator.userAgent;
  return /android|adr/i.test(u); // android终端
};

export const isWechat = () => {
  const u = navigator.userAgent.toLowerCase();
  return u.indexOf("micromessenger") > -1;
};

export const isQQ = () => {
  const u = navigator.userAgent.toLowerCase();
  return u.indexOf(" qq/") > -1;
};

/**
 * 是否是鸿蒙
 */
export const isHarmony = () => {
  const { userAgent } = window.navigator;

  return /OpenHarmony/i.test(userAgent);
};

// ios 或者 iPad
export const isIos = () => {
  const u = navigator.userAgent;
  return !!u.match(/(iPhone\sOS)\s([\d_]+)|iPad/); // ios
};

export const isXiaomiDevice = () => {
  const u = navigator.userAgent;
  return !!u.match(/Xiaomi\s([^;]+)/i);
};

export function openurl(url?: string) {
  if (url) {
    window.location.href = url;
  }
}

export const showVConsole = () => {
  if ((window as any).VConsole) {
    new (window as any).VConsole();
    return;
  }
  importScript({
    url: "https://gh.gtimg.com/hamster/public/libs/vconsole.min.js",
    id: "vconsole",
  }).then(() => {
    new (window as any).VConsole();
  });
};

// 动态显示时间转换
export const transTrendDate = (time: string) => {
  if (!time) return "";
  const date = dayjs(time);
  const currentDate = dayjs();
  const currentYear = currentDate.startOf("year");
  const sevenDayBefore = currentDate.subtract(6, "day").startOf("day");
  const yesterday = currentDate.subtract(1, "day").startOf("day");
  const currentDay = currentDate.startOf("day");

  if (date.isBefore(currentYear)) {
    // 早于今年
    return date.format("YYYY年MM月DD日 HH:mm");
  } else if (date.isAfter(currentDay)) {
    // 今早之后
    return date.format("HH:mm");
  } else if (date.isAfter(yesterday)) {
    // 昨早之后
    return date.format("昨天 HH:mm");
  } else if (date.isAfter(sevenDayBefore)) {
    // 6天前之后
    return date.format("dddd HH:mm");
  } else if (date.isBefore(sevenDayBefore)) {
    // 6天前之前
    return date.format("MM月DD日 HH:mm");
  } else {
    // 其他异常情况
    return date.format("YYYY年MM月DD日 HH:mm");
  }
};

/**
 * 判断当前是否在微信小程序、头条小程序、快应用等中
 */
export const isMiniApp = () => {
  const { userAgent } = navigator;
  if (
    (/miniProgram/i.test(userAgent) && /micromessenger/i.test(userAgent)) ||
    /toutiaomicroapp/i.test(userAgent) ||
    /AlipayClient/i.test(userAgent) ||
    (/miniProgram/i.test(userAgent) && /kwapp/i.test(userAgent))
  ) {
    return true;
  }
  return false;
};

// 判断是否是国聘幸福家 app
export const isApp = () => {
  let isApp = false;
  const agent = navigator.userAgent;
  if (agent) {
    if (agent.indexOf("Html5Plus") > -1 || agent.indexOf("sdichome") > -1) isApp = true;
  }
  return isApp;
};

/**
 * 将数字进行单位上的提升
 * @param num 要转换的数字
 * @param config 配置
 * @returns 转换后的数字
 */
export const transNum = (
  num: number,
  config?: {
    /**
     * 单位提升最多保留几位小数，若是整数则只有整数部分，若是小数且不设置时则默认保留1
     */
    decimal?: number;
    /**
     * 是否添加千分位的分隔符
     */
    thousandth?: boolean;
  }
) => {
  if (typeof num !== "number" || num < 1e3) {
    return num;
  }
  const w = 1e4;
  const sizes = ["", "万", "亿", "万亿"];
  const decimal = config?.decimal ?? 1;
  let i = 0;

  while (num >= w && i < sizes.length) {
    i++;
    num /= w;
  }
  const num0 = num.toFixed(0);
  const num1 = num.toFixed(decimal);

  return (+num0 === +num1 ? num0 : num1) + sizes[i];
};
// 动态显示时间转换
export const transTrendTime = (time: string) => {
  if (!time) return "";
  const date = dayjs(time);
  const year = date.get("year");
  const currentYear = dayjs(new Date()).get("year");

  if (year === currentYear) {
    return date.format("MM-DD HH:mm");
  }
  return date.format("YYYY-MM-DD HH:mm");
};

export function openApp(appScheme: string, universalLink?: string, toAbout = false) {
  // if (isIos() && universalLink) {
  //   window.location.href = universalLink;
  //   return;
  // }
  // if (isAndroid() && toAbout) {
  //   window.location.href = appScheme;
  //   return;
  // }
  console.log("openApp", appScheme, universalLink, toAbout);
  if (!appScheme) {
    window.location.href = _route.APP;
    return;
  }
  window.location.href = appScheme;

  let noJump = true;
  const startTime = +new Date();
  const listener = () => {
    // 不同⼿机不⼀样，⾃测 android chrome ⼤概 1s
    // 且有的⼿机会拦截，导致时间更⻓了，折中取 2s
    console.log("跳转耗时(ms):", +new Date() - startTime);
    if (document.hidden) {
      console.log(`检测到⻚⾯隐藏`);
      noJump = false;
    }
  };
  document.addEventListener("visibilitychange", listener);
  setTimeout(() => {
    if (noJump) {
      console.log(`未检测到⻚⾯隐藏，跳到下载`);
      window.location.href = _route.APP;
    }
    document.removeEventListener("visibilitychange", listener);
  }, 2000);
}

// 获取当天，近七天，近30天，近365天
export const getDateRange = (key: string): { startTime: string; endTime: string } => {
  const current = fomatDayjs(dayjs());
  switch (key) {
    case "day":
      return {
        startTime: current,
        endTime: current,
      };
    case "week":
      return {
        startTime: fomatDayjs(dayjs().subtract(6, "day")),
        endTime: current,
      };
    case "month":
      return {
        startTime: fomatDayjs(dayjs().subtract(29, "day")),
        endTime: current,
      };
    case "year":
      return {
        startTime: fomatDayjs(dayjs().subtract(1, "year")),
        endTime: current,
      };
    default:
      return {
        startTime: fomatDayjs(dayjs().subtract(6, "day")),
        endTime: current,
      };
  }
};
const fomatDayjs = (day: Dayjs) => {
  return dayjs(day).format("YYYY-MM-DD");
};

export const isCurrentVersionHigher = (currentVersion: any, targetVersion: any) => {
  // 将版本号按点号分割成数组
  const currentArray = currentVersion.split(".").map(Number);
  const targetArray = targetVersion.split(".").map(Number);
  // 找出较长的版本号数组长度
  const maxLength = Math.max(currentArray.length, targetArray.length);
  // 逐位比较版本号
  for (let i = 0; i < maxLength; i++) {
    // 如果当前版本号位数不足，补0
    const current = currentArray[i] || 0;
    const target = targetArray[i] || 0;
    // 如果当前位 current 大于 target，返回 true
    if (current > target) {
      return true;
    }
    // 如果当前位 current 小于 target，返回 false
    else if (current < target) {
      return false;
    }
  }
  // 如果所有位都相等，返回 true（表示当前版本等于目标版本）
  return true;
};

/**
 * 获取APP的版本号
 */
export const getAppVersion = (): string => {
  // iOS的APP，从5.0.200版本开始，版本会放在ua中
  const [match, version] = navigator.userAgent.match(/sdichome\/([\d.]+)/i) || [];
  if (match && version) {
    return version;
  }
  return "";
};

export const getWxOpenAppHtml = (extinfo: string, id = "launch_btn") => {
  return `<wx-open-launch-app
  style="position:absolute;top:0;left:0;right:0;bottom:0;"
  extinfo=${extinfo}
  id=${id}
  appid="wx836c6e3623cf6c24"
  >
  <template>
    <style>
    .launch-btn {
      width: 100%;
      height: 32px;
    }
    </style>
    <div class="launch-btn"></div>
  </template>
</wx-open-launch-app>`;
};

// 每个icon对应的后缀
export const extToIcons: {
  [type in FileType]: string[];
} = {
  word: [".doc", ".docx"],
  excel: [".xls", ".xlsx"],
  ppt: [".ppt", ".pptx"],
  pkg: [".zip", ".rar", ".7z", ".bz", ".gz", ".z"],
  video: [".mp4", ".avi", ".wmv", ".mpg", ".mov", ".swf", ".flv"],
  audio: [".mp3", ".wav"],
  pdf: [".pdf"],
  img: [".jpg", ".jpeg", ".png", ".webp", ".bmp", ".gif"],
};

export type FileType = "word" | "excel" | "ppt" | "pkg" | "video" | "audio" | "pdf" | "img";

/**
 * 从文件名中解析出后缀名，带小点dot
 * @param name 文件名
 * @returns 后缀名
 */
export const getExtByName = (name: string) => {
  if (!name) {
    return "";
  }
  const dotLastIndex = name.lastIndexOf(".");
  const extname = name.substring(dotLastIndex).toLowerCase();

  return extname;
};

/**
 * 通过后缀名得到该文件的类型
 * @param extname
 */
export const getIconTypeByExt = (extname: string): FileType => {
  const types = Object.keys(extToIcons) as FileType[];
  for (let i = 0; i < types.length; i++) {
    const key = types[i];
    const list = extToIcons[key];

    for (let i = 0; i < list.length; i++) {
      if (list[i] === extname) {
        return key;
      }
    }
  }

  // 没有匹配到后缀，则认为是图片格式
  return "img";
};

export function attachPropertiesToComponent<C, P extends Record<string, any>>(
  target: C,
  properties: P
): C & P {
  const result = target as any;
  if (target && properties) {
    for (const key in properties) {
      if (Object.prototype.hasOwnProperty.call(properties, key)) {
        result[key] = properties[key];
      }
    }
  }
  return result;
}

// 带精度的千分位转化
export const smartThousandsWithPrecision = (
  val: string | number,
  precision = 2,
  locale = "zh-CN"
) => {
  const precisionNumber = Math.pow(10, precision);
  let processedNum = parseFloat(`${val}`);
  if (Number.isNaN(processedNum)) return val;
  processedNum = Math.round(processedNum * precisionNumber) / precisionNumber;
  return processedNum.toLocaleString(locale, {
    minimumFractionDigits: precision,
    maximumFractionDigits: precision,
  });
};

// 复制文本
export function copyText(text: string, target: string, onSuccess?: () => void) {
  const clipboard = new ClipboardJs(target);
  clipboard.on("success", (e) => {
    onSuccess?.();
    e.clearSelection();
    clipboard.destroy();
  });
  clipboard.on("error", () => {
    Toast.show("复制失败");
    clipboard.destroy();
  });
}
